import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getAuthService } from '../../services/authService'
import { GenericSpinner } from '../../components/GenericSpinner/GenericSpinner'

export const LoginCallback = () => {

  const navigate = useNavigate()

  const url = new URL(window.location.href)
  const searchParams = url.searchParams
  const code = searchParams.get('code')

  useEffect(() => {
    if (!code) {
      return navigate('/')
    }
    const authService = getAuthService()
    authService.exchangeCodeForTokens(code)
  }, [code, navigate])

  return (
    <GenericSpinner />
  )
}